module.exports = __webpack_public_path__ + "img/Cost-logo.cbda22b6.svg";